"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./tags.sass");

var Tags =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Tags, _Component);

  function Tags() {
    (0, _classCallCheck2.default)(this, Tags);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tags).apply(this, arguments));
  }

  (0, _createClass2.default)(Tags, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          items = _this$props.items,
          onRemove = _this$props.onRemove,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["className", "items", "onRemove"]);
      var children = props.children || items.map(function (item, key) {
        return _react.default.createElement(Tag, (0, _objectSpread2.default)({
          key: key
        }, item, {
          onClick: onRemove
        }), item.label);
      });
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('tags', className)
      }, children);
    }
  }]);
  return Tags;
}(_react.Component);

exports.default = Tags;
Tags.propTypes = process.env.NODE_ENV !== "production" ? {
  tags: _propTypes.default.arrayOf(_propTypes.default.object),
  onRemove: _propTypes.default.func
} : {};

var Tag =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Tag, _PureComponent);

  function Tag() {
    (0, _classCallCheck2.default)(this, Tag);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tag).apply(this, arguments));
  }

  (0, _createClass2.default)(Tag, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          label = _this$props2.label,
          children = _this$props2.children,
          value = _this$props2.value,
          onIconClick = _this$props2.onIconClick,
          Icon = _this$props2.Icon,
          props = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "label", "children", "value", "onIconClick", "Icon"]);
      return _react.default.createElement("div", (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)('tag', className, {
          'tag--icon': !!Icon
        })
      }), _react.default.createElement("div", {
        className: "tag-content"
      }, label || children || value), Icon && _react.default.createElement(Icon, {
        onClick: onIconClick,
        className: "tag-icon"
      }));
    }
  }]);
  return Tag;
}(_react.PureComponent);

exports.Tag = Tag;
Tag.propTypes = process.env.NODE_ENV !== "production" ? {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  label: _propTypes.default.string,
  onIconClick: _propTypes.default.func,
  Icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(_react.Component)])
} : {};